import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import Invoices from './components/Invoices';
import PaymentMethod from './components/PaymentMethod';

import BillingAddress from './components/BillingAddress/BillingAddress';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import useSellerQueries from '@dashboard/hooks/queries/useSellerQueries';
import { sellerBillingAddress } from '@dashboard/lib/queryKeys';
import SettingsContainer from '@dashboard/components/SettingsContainer';
import SettingsHeader from '@dashboard/components/SettingsHeader';
import SettingsDivider from '@dashboard/components/SettingsDivider';

const Billing = () => {
  const { sellerId } = useAuth();
  const queryClient = useQueryClient();
  const { getSellerAddress } = useSellerQueries();

  const { data: address } = useQuery({
    queryKey: sellerBillingAddress(sellerId),
    queryFn: () => getSellerAddress(sellerId),
    enabled: !!sellerId,
    retry: false,
  });

  return (
    <SettingsContainer>
      <SettingsHeader id="business-address">Business address</SettingsHeader>
      <BillingAddress
        onSubmit={() => queryClient.invalidateQueries({ queryKey: sellerBillingAddress(sellerId) })}
      />

      <SettingsDivider />

      <SettingsHeader id="payment-method">Payment method</SettingsHeader>

      <PaymentMethod hasBillingAddress={Boolean(address)} />

      <SettingsDivider />

      <SettingsHeader id="invoices">Invoices</SettingsHeader>
      <Invoices />
    </SettingsContainer>
  );
};

export default Billing;
